
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
/**
 * @Description: 分销商后台管理系统--菜单
 * @author jing
 * @date 2021/1/19 9:49
 * @attribute name 名称
 * @attribute path 路径
 * @attribute icon 图标
 * @attribute children 子菜单
 * @attribute menuKey 菜单key(需要唯一，用于获取权限)
 * @attribute distributorType 分销商类型(ALIGJ: 阿里国际分销、YMS：云卖分销商)
 */

import store from "@/store/store";
import {commonLocalStorage, handleCommonMenuData} from "@/utils/common";
import {setConfigCharacters} from "@/utils/enum";

// 生成基础菜单结构，后续再根据最新配置做菜单隐藏和名称处理。
const createBaseMenuList = () => {
  return [
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007975'),
      icon: '&#xe6b2;',
      type: 'distributionMarket',
      path: '/distributionMarket',
      menuKey: 'distributor_distributionMarket',
      distributorType: ['ALIGJ']
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006967'),
      icon: '&#xe618;',
      type: 'productManagement',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001107'),
          path: '/myInventory',
          menuKey: 'distributor_myInventory',
          distributorType: ['YMS']
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007976'),
          path: '/commodityList',
          menuKey: 'distributor_commodityList',
          distributorType: ['YMS', 'ALIGJ'],
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003337'),
              path: '/viewCollectSku',
              menuKey: 'distributor_viewCollectSku',
              distributorType: ['YMS', 'ALIGJ'],
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007977'),
          path: '/designedProductsList',
          menuKey: 'distributor_designedProductsList',
          distributorType: ['YMS', 'ALIGJ'],
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003337'),
              path: '/viewCustomizedSku',
              menuKey: 'distributor_viewCustomizedSku',
              distributorType: ['YMS', 'ALIGJ'],
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007978'),
          path: '/generateSalesRecords',
          menuKey: 'distributor_generateSalesRecords',
          distributorType: ['YMS', 'ALIGJ']
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000007'),
          type: 'toListing',
          jurisdictionHide: true, // 不需要权限判断
          hideMenu: true, // 在角色管理中不展示此菜单
          externalLink: true, // 是否跳转到外部系统的标识
          menuKey: 'distributor_shelfTools',
          distributorType: ['YMS', 'ALIGJ']
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007979'),
      icon: '&#xe6fe;',
      type: 'automaticRules',
      path: '/automaticRules',
      menuKey: 'distributor_automaticRules',
      distributorType: ['YMS', 'ALIGJ']
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007980'),
      icon: '&#xe604;',
      path: '/platformStoreList',
      type: 'storeManagement',
      menuKey: 'distributor_platformStoreList',
      distributorType: ['YMS', 'ALIGJ']
    },
    // TE-30731 需求调整，先暂时屏蔽
    /*{
      name: '我的收藏',
      icon: '&#xe63a;',
      children: [
        {
          name: '收藏的供应商',
          path: '/collectionSupplier',
          menuKey: 'distributor_collectionSupplier',
          distributorType: ['YMS']
        }
      ]
    },*/
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001535'),
      icon: '&#xe668;',
      type: 'orderManagement',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005609'),
          path: '/platformOrder',
          menuKey: 'distributor_platformOrder',
          distributorType: ['YMS', 'ALIGJ'],
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007981'),
              path: '/platformDetails',
              menuKey: 'distributor_platformDetails',
              distributorType: ['YMS', 'ALIGJ'],
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007982'),
              path: '/addTemuOrder',
              menuKey: 'distributor_addTemuOrder',
              distributorType: ['YMS', 'ALIGJ'],
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`,
          path: '/myOrder',
          menuKey: 'distributor_myOrder',
          distributorType: ['YMS'],
          children: [
            {
              name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006135')}`,
              path: '/myOrderDetails',
              menuKey: 'distributor_myOrderDetails',
              distributorType: ['YMS'],
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006171'),
              path: '/addCloudSalesOrder',
              menuKey: 'distributor_addCloudSalesOrder',
              distributorType: ['YMS'],
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005610'),
          path: '/distributorStockList',
          menuKey: 'distributor_distributorStockList',
          distributorType: ['YMS'],
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001930'),
              path: '/createBackupOrder',
              menuKey: 'distributor_createBackupOrder',
              distributorType: ['YMS'],
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007963'),
              path: '/distributorStockListDetails',
              menuKey: 'distributor_distributorStockListDetails',
              distributorType: ['YMS'],
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007983'),
          path: '/paymentManagement',
          menuKey: 'distributor_paymentManagement',
          distributorType: ['YMS'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007984'),
          path: '/orderImportTemplateList',
          menuKey: 'distributor_orderImportTemplateList',
          distributorType: ['YMS'],
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001536'),
      icon: '&#xe645;',
      type: 'financialManagement',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002931'),
          path: '/rechargeRecord',
          menuKey: 'distributor_rechargeRecord',
          distributorType: ['YMS'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003683'),
          path: '/financialJournal',
          menuKey: 'distributor_financialJournal',
          distributorType: ['YMS'],
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007928'),
      icon: '&#xe68e;',
      type: 'logisticsManagement',
      children: [
        {
          name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}`,
          path: '/logisticsSettings',
          menuKey: 'distributor_logisticsSettings',
          distributorType: ['YMS'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587'),
          path: '/ownLogistics',
          menuKey: 'distributor_ownLogistics',
          distributorType: ['YMS'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007930'),
          path: '/smartRule',
          menuKey: 'distributor_smartRule',
          distributorType: ['YMS'],
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007931'),
      icon: '&#xe605;',
      type: 'warehouseManagement',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007985'),
          path: '/repositoryList',
          menuKey: 'distributor_repositoryList',
          distributorType: ['YMS'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007986'),
          path: '/intelligentWarehouseRules',
          menuKey: 'distributor_intelligentWarehouseRules',
          distributorType: ['YMS'],
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005989'),
      icon: '&#xe98c;',
      type: 'complianceInformation',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007987'),
          path: '/complianceResponsiblePersonList',
          menuKey: 'distributor_complianceResponsiblePersonList',
          distributorType: ['YMS'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007988'),
          path: '/manufacturerInfoList',
          menuKey: 'distributor_manufacturerInfoList',
          distributorType: ['YMS'],
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007989'),
      icon: '&#xe61b;',
      type: 'permissionManagement',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007990'),
          path: '/roleManage',
          menuKey: 'distributor_roleManage',
          distributorType: ['YMS', 'ALIGJ'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007991'),
          path: '/userManage',
          menuKey: 'distributor_userManage',
          distributorType: ['YMS', 'ALIGJ'],
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000037'),
      path: '/newsList',
      menuKey: 'distributor_newsList',
      distributorType: ['YMS', 'ALIGJ'],
      menuHide: true,
      type: 'messageCenter',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007992'),
          path: '/newsListDetails',
          menuKey: 'distributor_newsListDetails',
          distributorType: ['YMS', 'ALIGJ'],
          menuHide: true
        }
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007993'),
      icon: '&#xe627;',
      type: 'accountManagement',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          path: '/basicInformation',
          menuKey: 'distributor_basicInformation',
          distributorType: ['YMS', 'ALIGJ'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007994'),
          path: '/securityInformation',
          menuKey: 'distributor_securityInformation',
          distributorType: ['YMS', 'ALIGJ'],
          children: [
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005514'),
              path: '/modifyMobile',
              menuKey: 'distributor_modifyMobile',
              distributorType: ['YMS', 'ALIGJ'],
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005515'),
              path: '/modifyMailbox',
              menuKey: 'distributor_modifyMailbox',
              distributorType: ['YMS', 'ALIGJ'],
              menuHide: true // 菜单不展示
            },
            {
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005860'),
              path: '/modifyPassword',
              menuKey: 'distributor_modifyPassword',
              distributorType: ['YMS', 'ALIGJ'],
              menuHide: true // 菜单不展示
            }
          ]
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005450'),
          path: '/iossManageList',
          menuKey: 'distributor_iossManageList',
          distributorType: ['YMS'],
        },
      ]
    },
    {
      name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007957'),
      icon: '&#xe6a9;',
      type: 'importTask',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007958'),
          path: '/importTask',
          menuKey: 'distributor_importTask',
          distributorType: ['YMS', 'ALIGJ'],
        },
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007959'),
          path: '/exportTask',
          menuKey: 'distributor_exportTask',
          distributorType: ['YMS', 'ALIGJ'],
        }
      ]
    },
    {
      name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000009')}`,
      type: 'ymsShopping',
      children: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007995'),
          menuKey: 'shop_shopList',
          distributorType: ['YMS'],
        }
      ]
    }
  ];
};

export const getDistributorMenu = () => {
  let distributorMenuList = createBaseMenuList();
  const configurationItemInfo = commonLocalStorage.getItem('configurationItemInfo') ?? store.state.configurationItemInfo;
  const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? store.state.saasConfigurationItems;

  // 线下支付配置停用时，不显示【订单管理--付款管理】菜单
  const offlinePaymentDisabled = Number(configurationItemInfo?.offlinePayment) === 0;
  if (offlinePaymentDisabled) {
    distributorMenuList = handleCommonMenuData(distributorMenuList, {
      hideMenuKeys: [
        'distributor_paymentManagement'
      ],
      hideTypes: ['orderManagement']
    });
  }
  // 订单合规标签校验配置停用时，不显示【合规信息模块】菜单
  const orderComplianceLabelVerificationDisabled = Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 0;
  if (orderComplianceLabelVerificationDisabled) {
    distributorMenuList = handleCommonMenuData(distributorMenuList, {
      hideMenuKeys: [
        'distributor_complianceResponsiblePersonList',
        'distributor_manufacturerInfoList'
      ],
      hideTypes: ['complianceInformation']
    });
  }

  return distributorMenuList;
};

export default {
  get menu() {
    return getDistributorMenu();
  }
};
